<template>
  <div :id="`card-${item.short_id}`" class="h-100">
    <div class="pt-1 h-100" :class="fromProvider ? 'hide-provider' : 'show-provider'">
      <div
        data-gtm-att="ga-CC05-1-01"
        class="new-api-card card card-frame h-100 mr-1 ml-1 cursor-pointer"
        data-container="body"
        :class="fromProvider ? 'hide-provider' : 'show-provider'"
        @click="(e) => clickCard(e, item)"
      >
        <div v-show="loading">
          <div class="api-card border-0">
            <div class="api-card-info d-flex justify-content-between align-items-md-center pt-4 px-4">
              <SkeletonUI type="span" class="skeleton-span" />
            </div>
          </div>
          <div class="card-body d-flex flex-column">
            <SkeletonUI type="h4" :lines="2" class="mb-3 skeleton-name" />
            <SkeletonUI type="p" :lines="2" class="skeleton-description" />
            <div v-if="!fromProvider" class="d-flex align-items-center mt-auto">
              <div class="avatar avatar-md mr-2 border">
                <SkeletonUI type="img" class="avatar-img" />
              </div>
              <SkeletonUI type="span" class="skeleton-provider-name" />
            </div>
          </div>
        </div>
        <div v-if="!loading" class="api-card border-0">
          <div class="api-card-info d-flex justify-content-between align-items-md-center pt-4 px-4">
            <span v-if="item.api_category !== null" class="api-category">{{ getCategoryName(item.api_category) }}</span>
            <div class="text-md-right">
              <template>
                <span :class="permissionType.type">
                  {{ $t(permissionType.name) }}
                </span>
              </template>
              <template v-if="item.show_analytics">
                <b-popover :target="`card-${item.short_id}`" class="analytics-popover" triggers="hover" placement="rightbottom" data-toggle="tooltip" data-container="body">
                  <span class="small pb-1">{{ $t('CC05-1-05a') }}</span><br>
                  <i class="statistics-icon far fa-arrow-alt-circle-down mr-1" /><span v-html="$t('CC05-1-05b-01', { total_num: item.api_no_of_calls })" /><br>
                  <i class="statistics-icon far fa-check-circle mr-1" /><span v-html="$t('CC05-1-05b-02', { success_rate: item.api_errors_percentage !== null ? item.api_errors_percentage : '-' })" /><br>
                  <i class="statistics-icon far fa-clock mr-1" /><span v-html="$t('CC05-1-05b-03', { latency: item.api_latency !== null ? item.api_latency : '-' })" />
                </b-popover>
              </template>
            </div>
          </div>
        </div>
        <div v-if="!loading" class="card-body d-flex flex-column">
          <h4 class="mb-2 text-truncate-2">{{ item.api_name }}</h4>
          <p class="text-truncate-3 mb-2">{{ item.api_description }}</p>
          <div class="mt-auto">
            <div v-if="item.has_swagger_file" class="badge badge-soft-secondary no-spec-badge mb-5">{{ $t('CC05-1-06') }}</div>
            <div v-if="!fromProvider" class="d-flex align-items-center">
              <div class="avatar avatar-md mr-2 border">
                <img v-img="{ type:'small' }" class="avatar-img" width="30" height="30" :src="(item.provider_profile_picture_url) ? item.provider_profile_picture_url : require('@/assets/img/provider-default/default-icon.jpg')">
              </div>
              <span class="small ml-1 display-name">{{ item.display_name }}</span>
              <div v-if="item.verification_status === 'verified' && getEditableInfo('enabled_function', 'verification_badge', false)" id="verification-badge-container" class="verification-badge-container">
                <VerificationBadge :id="item.short_id" :isTextShown="false" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LoginPopup ref="loginPopup" :item="item" :afterLogin="afterLogin" />
  </div>
</template>

<script>
const $ = require('jquery')
import { getCategoryCode } from '@/utils/format-util'
import LoginPopup from '@/components/login-popup'
import SkeletonUI from './skeleton-ui.vue'
import DummyApiCardData from '@/data/api-card-dummy-data'
import VerificationBadge from '@/components/verification-badge'
import getEditableInfo from '@/utils/get-editable-info'

export default {
  name: 'ApiCardBranded',
  components: {
    LoginPopup,
    SkeletonUI,
    VerificationBadge
  },
  props: {
    fromApiCarousel: {
      type: Boolean,
      default: false
    },
    useCase: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {
        return DummyApiCardData
      }
    },
    clickHandler: {
      type: Function,
      default: () => {}
    },
    fromProvider: {
      type: Boolean,
      default: false
    },
    afterLogin: {
      type: String,
      default: 'apiReadmeBranded'
    },
    carouselId: {
      type: String,
      default: 'carousel'
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    loggedIn() {
      return this.$store.getters.login
    },
    userProfile() {
      return this.$store.getters.userProfile
    },
    permissionType() {
      const permission = {
        type: '',
        name: ''
      }
      switch (this.item.api_type) {
        case 'public':
        case 'fabrix-public-oah-public':
        case 'fabrix-public-oah-private':
          permission['type'] = 'permission-badge-public'
          permission['name'] = 'apidetails-02-01'
          break
        case 'oah-member':
          permission['type'] = 'permission-badge-member'
          permission['name'] = 'apidetails-02-02'
          break
        case 'partner':
          permission['type'] = 'permission-badge-partner'
          permission['name'] = 'apidetails-02-03'
          break
        case 'private':
          permission['type'] = 'permission-badge-private'
          permission['name'] = 'apidetails-02-04'
          break
        case 'fabrix-unlisted':
          permission['type'] = 'permission-badge-private'
          permission['name'] = 'apidetails-02-06'
          break
        default:
          permission['type'] = 'permission-badge-draft'
          permission['name'] = 'apidetails-02-05'
          break
      }
      return permission
    }
  },
  methods: {
    clickCard(e, item) {
      if ($(e.target).is('img') || $(e.target).is('a')) return
      if ((this.loggedIn && this.userProfile.id !== '') || (item?.api_type === 'public') || (item?.api_type.includes('fabrix-public'))) {
      // if ((item?.api_type === 'public')) {
        this.clickHandler(item)
      } else {
        this.$refs['loginPopup'].showFormDialog()
      }
    },
    goToProvider(item) {
      const location = window.location.href
      const index = location.indexOf('#')
      const currPos = location.slice(index - 1)
      var link = '/v/'.concat(item.display_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-'), (`-${item.short_id}`), '/home').replace(/\-+/g, '-')
      if (currPos !== link) {
        window.location.assign(link)
      } else {
        document.location.reload(true)
      }
    },
    goToCategory(category) {
      this.$router.push({ name: 'api-catalogue', params: { category: category }})
    },
    formatString(string) {
      return string.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').replace(/\-+/g, '-')
    },
    getCategoryName(category) {
      return this.$t(getCategoryCode(category))
    },
    getEditableInfo(type, id, withLangCode = true) {
      return getEditableInfo(type, id, withLangCode ? this.$i18n.locale.toLowerCase() : '')
    }
  }
}
</script>

<style lang="scss" scoped>
.new-api-card {
  box-shadow: none;
}
.cursor-pointer {
  cursor: pointer;
}
.api-category {
  font-size: 12px;
  font-weight: 600;
  color: #505050;
  max-width: calc(100% - 60px);
}
.icons {
  color: #CED5DD;
  font-size: 16px;
  + .icons {
    margin-left: 12px;
  }
}
.statistics-icon {
  font-size: 14px;
}
.small {
  font-size: 12px;
  line-height: 17px;
  color: #999;
}
.display-name {
  display: inline-block;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.avatar {
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  .avatar-img {
    width: 100%;
    height: 100%;
  }
}
.text-truncate-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
span[class^="permission-badge"] {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  left: 29px;
  height: 20px;
  padding: 0 12px;
  border-radius: 1px 1px 0 1px;
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
  margin-left: 8px;
}
span[class^="permission-badge"]::after {
  position: absolute;
  right: 0;
  bottom: -4px;
  width: 4px;
  height: 4px;
  content: '';
}
.permission-badge-draft {
  color: #596D82;
  background-color: #FFFFFF;
  border: 1px solid #E5E9ED;
  &::after {
    background: #D9DFE5;
    background: linear-gradient(315deg, #FFFFFF00 50%, #D9DFE5 50%);
  }
}
.permission-badge-public {
  color: #FFFFFF;
  background-color: #57ABF0;
  &::after {
    background: #4A90E2;
    background: linear-gradient(315deg, #FFFFFF00 50%, #4A90E2 50%);
  }
}
.permission-badge-member {
  color: #FFFFFF;
  background-color: #1C344C;
  &::after {
    background: #000000;
    background: linear-gradient(315deg, #FFFFFF00 50%, #000000 50%);
  }
}
.permission-badge-partner {
  color: #FFFFFF;
  background-color: #71869D;
  &::after {
    background: #4F5D6D;
    background: linear-gradient(315deg, #FFFFFF00 50%, #4F5D6D 50%);
  }
}
.permission-badge-private {
  color: #596D82;
  background-color: #E5E9ED;
  &::after {
    background: #D9DFE5;
    background: linear-gradient(315deg, #FFFFFF00 50%, #D9DFE5 50%);
  }
}
.skeleton-description {
  margin-bottom: 16px;
}
.skeleton-provider-name {
  width: 100%;
  &::v-deep .span{
    height: 17px;
  }
}
.verification-badge-container {
  margin-left: 5px;
}
.skeleton-span {
  width: 60%;
}
.analytics-popover {
  z-index: 1020;
}

.no-spec-badge {
  width: fit-content;
}
</style>
